import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO } from '../data/staticData';
import ContactForm from '../components/ContactForm';

export default function AboutPage() {
  return (
    <div className="bg-white">
      {/* Profil Indhold */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 lg:pt-20 pb-16">
        
        {/* Header */}
        <div className="text-left max-w-4xl space-y-6 mb-12 sm:mb-16">
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 tracking-tight uppercase">
            Jysk tagfirma med kunder i hele landet
          </h1>
          <p className="text-stone-700 text-lg sm:text-xl leading-relaxed">
            Hos Dansk Tagbyg har vi siden 2016 udført alle former for tagdækning samt energirenovering af boliger over hele landet. Vi påtager os opgaver i hele Danmark og tilbyder tagløsninger til både private og erhvervskunder.
          </p>
        </div>

        {/* 2-kolonne layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 sm:gap-16 items-start">
          
          {/* Venstre sektion - brødtekst */}
          <div className="lg:col-span-8 space-y-8 text-stone-700 text-sm sm:text-base leading-relaxed">
            <p>
              Intet hus eller husstand er ens, og hvad der er mest optimalt for lige netop dig, er ikke nødvendigvis den bedste løsning for naboen. Med vores brede erfaring er vi eksperter i forskellige materialer, løsninger og krav, og vi kan rådgive og vejlede dig til den rette løsning til netop dit hus.
            </p>

            <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 uppercase pt-2">
              Målet er altid glade kunder
            </h2>
            <p>
              Vores håndværkere er specialister inden for tagdækning, energirigtig isolering, vinduer og døre og har mange års erfaringen inden for feltet. Vi udfører alle typer af tagdækningsopgaver, uanset om det gælder renovering, vedligeholdelse eller helt nyt tag.
            </p>
            <p>
              Det er vigtigt for os, at du som kunde føler dig tryg i vores vejledning, og at vi i fællesskab finder frem til den bedste løsning til din bolig. Vi benytter altid kun kvalitetsprodukter, da det – kombineret med vores høje faglighed og dialog til kunden – sikrer de bedste løsninger.
            </p>

            {/* Billede */}
            <div className="border border-stone-200 overflow-hidden my-6">
              <img
                src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/thumb.webp"
                alt="Dansk Tagbyg Profil"
                className="w-full h-auto object-cover"
              />
            </div>

            <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 uppercase pt-2">
              Stærkt team af tillidsfulde håndværkere
            </h2>
            <p>
              Tillid og håndværkere går desværre ikke altid hånd i hånd, men vi lægger en ære i, at vores kunder føler sig hørt og går fra samarbejdet med en god oplevelse. Vi er et forholdsvist lille, men stærkt team af dygtige håndværkere, som alle går til en ny opgave med smil, gåpåmod og høj arbejdsmoral.
            </p>
            <p>
              Vores håndværkere er uddannet og arbejder tæt sammen med førende producenter som Swisspearl. Vi kan derfor tilbyde dig solid tryghed og markedets stærkeste garantier på både produkter, materialer og udførelse.
            </p>
            <p className="pt-2">
              Har du lyst til at blive en del af teamet? Se vores{' '}
              <Link to="/job" className="text-[#BE0F12] font-bold underline hover:text-black">
                ledige stillinger her
              </Link>{' '}
              eller søg uopfordret.
            </p>
          </div>

          {/* Højre kolonne - Kontakt & Prisberegner kort */}
          <div className="lg:col-span-4 space-y-6">
            {/* Kontakt mig, Lasse */}
            <div className="bg-stone-50 border border-stone-200 p-6 sm:p-8 space-y-4">
              <h3 className="text-lg font-bold text-stone-900 uppercase">
                Kontakt mig, Lasse
              </h3>
              <div className="space-y-2 text-sm text-stone-700">
                <p>
                  <strong>Ring:</strong>{' '}
                  <a href={`tel:${COMPANY_INFO.phone}`} className="text-[#BE0F12] font-semibold hover:underline">
                    {COMPANY_INFO.phoneFormatted}
                  </a>
                </p>
                <p>
                  <strong>Skriv:</strong>{' '}
                  <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#BE0F12] font-semibold hover:underline">
                    {COMPANY_INFO.email}
                  </a>
                </p>
              </div>
              <a
                href="#kontakt"
                className="inline-block w-full text-center px-6 py-3 bg-[#BE0F12] hover:bg-[#a00d0f] text-white font-bold text-sm tracking-wider uppercase transition-colors"
              >
                Kontakt os
              </a>
            </div>

            {/* Lasse profilbillede som på originalen */}
            <div className="flex flex-row items-end justify-center gap-2 sm:gap-3 pt-2">
              <img
                src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/har-du-sporgsmaal.png"
                alt="Har du spørgsmål, så tag fat i mig!"
                className="w-[42%] max-w-[145px] h-auto object-contain self-center"
              />
              <img
                src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/lasse-sidebar.png"
                alt="Lasse Vesterhouen - Dansk Tagbyg"
                className="w-[58%] max-w-[200px] h-auto object-contain"
              />
            </div>

            {/* Prisberegner boks */}
            <div className="bg-stone-50 border border-stone-200 p-6 sm:p-8 space-y-4">
              <h3 className="text-lg font-bold text-stone-900 uppercase">
                Få et uforpligtende tilbud – Prisberegner: Nyt tag
              </h3>
              <p className="text-sm text-stone-600 leading-relaxed">
                Ud fra 4 simple spørgsmål beregner vi med det samme en uforpligtende pris til dig på nyt tag. Hurtigt og nemt!
              </p>
              <Link
                to="/prisberegner"
                className="inline-block w-full text-center px-6 py-3 bg-stone-900 hover:bg-black text-white font-bold text-sm tracking-wider uppercase transition-colors"
              >
                Prisberegner: Nyt tag
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bund: Anmeldelser og Kontaktformular (som på originalen) */}
      <section id="kontakt" className="py-16 sm:py-24 bg-stone-100 border-t border-stone-200 scroll-mt-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 sm:gap-16 items-start">
            
            {/* Venstre kolonne: Firmaoplysninger og Anmeld Håndværker */}
            <div className="lg:col-span-5 space-y-8">
              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-3">
                <div className="flex items-center gap-1 text-amber-500 text-lg">
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                </div>
                <a
                  href="https://www.anmeld-haandvaerker.dk/tagdaekker/dansk-tagbyg-aps"
                  target="_blank"
                  rel="noreferrer"
                  className="block font-black text-xl text-stone-900 hover:text-[#BE0F12] transition-colors"
                >
                  4,8 ud af 155 anmeldelser
                </a>
                <p className="text-xs text-stone-500">
                  Finalist til Årets Håndværker 5 år i træk
                </p>
              </div>

              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-4 text-sm text-stone-700">
                <h3 className="font-extrabold text-xl text-stone-900 uppercase">
                  Dansk Tagbyg ApS
                </h3>
                <div className="space-y-2">
                  <p>
                    <strong className="text-stone-900">Ring:</strong>{' '}
                    <a href={`tel:${COMPANY_INFO.phone}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.phoneFormatted}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Skriv:</strong>{' '}
                    <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.email}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Adr:</strong> {COMPANY_INFO.address}
                  </p>
                  <p>
                    <strong className="text-stone-900">CVR:</strong> {COMPANY_INFO.cvr}
                  </p>
                </div>
                <div className="pt-3 border-t border-stone-200">
                  <p className="font-bold text-stone-900">Vi løser opgaver i hele DK</p>
                </div>
                <div className="pt-2">
                  <p className="text-xs font-bold text-stone-500 uppercase tracking-wider mb-2">Vi er medlem af</p>
                  <div className="flex flex-wrap items-center gap-3">
                    <img
                      src="/_assets/swisspearl-logo.png"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/swisspearl-logo.png';
                      }}
                      alt="Swisspearl"
                      className="h-7 sm:h-8 w-auto object-contain"
                    />
                    <img
                      src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/imgi-12-thumb.png"
                      alt="Byg Garanti"
                      className="h-6 w-auto object-contain"
                    />
                    <img
                      src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/imgi-11-thumb.png"
                      alt="DI Byggeri"
                      className="h-6 w-auto object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Højre kolonne: Kontaktformular */}
            <div className="lg:col-span-7 bg-white border border-stone-200 p-8 sm:p-10 shadow-sm">
              <ContactForm idPrefix="about" submitButtonText="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
